export type StatsTimelineSelectionTarget = {
  timestamp: number;
  x: number;
};

export type StatsTimelineSelectionTargets = {
  fallbackTimestamp: number | null;
  positions: readonly (StatsTimelineSelectionTarget & { originalIndex: number })[];
};

/** Project on JS after layout; only numeric positions cross into gesture worklets. */
export function buildStatsTimelineSelectionTargets(
  targets: readonly StatsTimelineSelectionTarget[],
): StatsTimelineSelectionTargets {
  const sorted = targets
    .map((target, originalIndex) => ({ ...target, originalIndex }))
    .filter((target) => Number.isFinite(target.x))
    .sort((a, b) => a.x - b.x || a.originalIndex - b.originalIndex);
  return {
    // The previous scan initialized its selection to the first datum, including
    // when every distance was invalid. Preserve that fallback and input-order ties.
    fallbackTimestamp: targets[0]?.timestamp ?? null,
    positions: sorted.filter((target, index) => index === 0 || target.x !== sorted[index - 1]?.x),
  };
}
